/**
 * Currency symbol position - runtime fallback.
 *
 * The theme's own sections route prices through snippets/currency-symbol-position.liquid
 * at render time. Page-builder sections (GemPages) are generated files that get rewritten
 * whenever a merchant republishes a page, so a Liquid edit there would not survive; this
 * repositions those prices in the DOM instead.
 *
 * Reads window.themeCurrencySymbolPosition = { position, space }, set from theme settings.
 * Mirrors the Liquid snippet exactly, so a price handled by either path renders the same.
 */
(function () {
  var cfg = window.themeCurrencySymbolPosition || {};
  var mode = cfg.position;
  if (mode !== 'before' && mode !== 'after') return;
  var separator = cfg.space === false ? '' : ' ';

  // .gp-* = GemPages page builder. .money = Shopify's standard money wrapper, which is
  // what the Frequently Bought Together app (cbb-frequently-bought-box) renders into.
  var SELECTOR = '.gp-money, .gp-price, .gp-product-compare-price, .gp-button-price, .money';

  // Only rewrite text that is a price and nothing else. The FBT widget puts prose and
  // <option> labels containing prices right next to its price spans - e.g.
  // "Sparen Sie 20 EUR, wenn Sie zusammen kaufen" and "2 Batterien (189.99EUR/Batterie)" -
  // and reordering a symbol inside a sentence would corrupt it.
  var STANDALONE_PRICE = /^\s*[^\w\s]*\s*\d[\d.,\s\u00a0]*[^\w\s]*\s*(?:[A-Za-z]{3})?\s*$/;

  function reposition(value) {
    if (typeof value !== 'string' || !/\d/.test(value)) return value;
    if (!STANDALONE_PRICE.test(value)) return value;

    // keep the text node's own leading whitespace where it is
    var lead = value.match(/^\s*/)[0];
    var inner = value.slice(lead.length);

    var first = inner.search(/\d/);
    if (first === -1) return value;
    var last = -1;
    for (var i = inner.length - 1; i >= 0; i--) {
      if (inner[i] >= '0' && inner[i] <= '9') { last = i; break; }
    }

    var prefix = inner.slice(0, first).trim();
    var number = inner.slice(first, last + 1);
    var tail = inner.slice(last + 1);
    var suffix = tail.trim();
    var trailWS = tail.slice(suffix.length ? tail.indexOf(suffix) + suffix.length : 0);

    if (mode === 'after') {
      if (!prefix) return value;
      return lead + number + separator + prefix + (suffix ? ' ' + suffix : '') + trailWS;
    }

    if (prefix || !suffix) return value;
    var moved = [], kept = [];
    suffix.split(/\s+/).forEach(function (token) {
      (/[a-z]/i.test(token) ? kept : moved).push(token);
    });
    if (!moved.length) return value;
    return lead + moved.join('') + number + (kept.length ? ' ' + kept.join(' ') : '') + trailWS;
  }

  // Only direct child text nodes, so nested markup and event listeners are left alone.
  function apply(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType !== 3) continue;
      var next = reposition(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) root = document.body;
    if (!root) return;
    if (root.matches && root.matches(SELECTOR)) apply(root);
    var found = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < found.length; i++) apply(found[i]);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      queued = false;
      scan(document.body);
    }, 0);
  }

  function start() {
    scan(document.body);
    if (!window.MutationObserver || !document.body) return;
    // Page-builder sections render and re-render client side (variant switches, lazy blocks).
    // Repositioning is idempotent, so the observer settles after one extra no-op pass.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
